import React from 'react';
import { Typography } from '@mui/material';
import { WhosOnline } from '../room/types';
import { timeSince } from '@par/shared/utils/date-time';

type Props = {
  player: WhosOnline;
};

export const PlayerActivityStatus = ({ player }: Props) => {
  return player.online && player.isIdle ? (
    <Typography variant="caption" color="info.main">
      Idle
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingSolo ? (
    <Typography variant="caption" color="success.main">
      Playing a Solo
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingMatch ? (
    <Typography variant="caption" color="success.main">
      Playing a Match
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingSnG ? (
    <Typography variant="caption" color="success.main">
      Playing a Sit & Go
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingTeams ? (
    <Typography variant="caption" color="success.main">
      Playing Teams
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingDaily ? (
    <Typography variant="caption" color="success.main">
      Playing a Daily
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingStarterKit ? (
    <Typography variant="caption" color="success.main">
      Playing {player.isPlayingStarterKit}
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingGhostChallenge ? (
    <Typography variant="caption" color="success.main">
      Playing a Ghost Challenge
    </Typography>
  ) : player.online && !player.isIdle && player.isSeedingGame ? (
    <Typography variant="caption" color="success.main">
      Seeding a game
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingSearchedGame ? (
    <Typography variant="caption" color="success.main">
      Playing a Searched Match
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingDailyTower ? (
    <Typography variant="caption" color="success.main">
      Playing the Daily Tower
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingSurvivalEndurance ? (
    <Typography variant="caption" color="success.main">
      Playing an Endurance Survival
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingSurvivalChallenge ? (
    <Typography variant="caption" color="success.main">
      Playing the Challenge Tower
    </Typography>
  ) : player.online && !player.isIdle && player.isPlayingDemons ? (
    <Typography variant="caption" color="success.main">
      Facing demons
    </Typography>
  ) : player.online && !player.isIdle ? (
    <Typography variant="caption" color="success.main">
      Online
    </Typography>
  ) : (
    <Typography variant="caption">
      Last online: {timeSince(new Date(player.disconnectedAt))} ago
    </Typography>
  );
};
